import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AvatarSing, LogoutPerson, Person } from '@yme/assets/icons';
import { OverflowMenu } from '@yme/atoms/overflow-menu';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { setIsLoadedLogoutIframe } from '@yme/components/Header/ProfileMenu/redux/actions';
import { useAuthorization } from '@yme/hooks/index';
import { getIsNavLoggedInIndicatorEnabled } from '@yme/selectors/common';
import { hasMobileDevice } from '@yme/utils/common';
import { getAuthorizedStatus, getIsLoadedLogoutIframe, getProfileData, getProfileMenuData, } from '../ProfileMenu/redux/selectors';
import { buildEndpointLogOut } from './helpers';
import { AuthorizedSingCircle, IframeStyle, SignInMenuItemStyled } from './styled';
import { useProfileMenu } from './useProfileMenu';
import { useTouchingSignInMenu } from './useTouchingSignInMenu';
export function SignInMenuItem({ isRightToLeft }) {
    const dispatch = useDispatch();
    const [isLoadedIframe, setIsLoadedIframe] = useState(false);
    const [isShowMenu, setIsShowMenu] = useState(false);
    const { myYamahaLink } = useSelector(getProfileMenuData);
    const isAuthorized = useSelector(getAuthorizedStatus);
    const { initials } = useSelector(getProfileData);
    const isLoadedLogoutIframe = useSelector(getIsLoadedLogoutIframe);
    const isNavLoggedInIndicatorEnabled = useSelector(getIsNavLoggedInIndicatorEnabled);
    const refItemProfileMenu = useRef(null);
    const { dropDownList } = useProfileMenu();
    const { isTouched } = useTouchingSignInMenu({
        ref: refItemProfileMenu,
    });
    const { setUnauthorized } = useAuthorization();
    const iframeLogOutPath = buildEndpointLogOut({
        myYamahaLink,
    });
    const isMobileDevice = hasMobileDevice();
    const setIsLogOutIframe = useCallback((value) => {
        dispatch(setIsLoadedLogoutIframe(value));
    }, [dispatch]);
    useEffect(() => {
        if (isAuthorized) {
            setIsLoadedIframe(false);
        }
    }, [isAuthorized]);
    useEffect(() => {
        if (isLoadedIframe) {
            // Remove iframe from the DOM
            setIsLogOutIframe(false);
            setUnauthorized();
        }
    }, [isLoadedIframe, setIsLogOutIframe, setUnauthorized]);
    const handleOpenMenu = useCallback(() => {
        setIsShowMenu(true);
    }, []);
    const handleCloseMenu = useCallback(() => {
        setIsShowMenu(false);
    }, []);
    const onLoadIframe = useCallback(() => {
        setIsLoadedIframe(true);
    }, []);
    if (isAuthorized) {
        return (React.createElement(React.Fragment, null,
            React.createElement(SignInMenuItemStyled, { isAuthorized: true, isMobileDevice: isMobileDevice, isMobileTouched: isTouched, ref: refItemProfileMenu, tabIndex: 0, onMouseEnter: handleOpenMenu, onMouseLeave: handleCloseMenu },
                React.createElement(SVGIcon, { type: AvatarSing, size: ICON_SIZE.xm },
                    React.createElement(AuthorizedSingCircle, null, initials)),
                isShowMenu && (React.createElement(OverflowMenu, { items: dropDownList, isRightToLeft: isRightToLeft, onClickMenu: handleCloseMenu }))),
            isLoadedLogoutIframe && (React.createElement(React.Fragment, null,
                React.createElement(SpinnerLoader, { isLoading: true, fullWidth: true }),
                React.createElement(IframeStyle, { src: iframeLogOutPath, onLoad: onLoadIframe })))));
    }
    return (React.createElement(SignInMenuItemStyled, { isMobileDevice: isMobileDevice, isMobileTouched: isTouched, ref: refItemProfileMenu, tabIndex: 0, onMouseEnter: handleOpenMenu, onMouseLeave: handleCloseMenu },
        React.createElement(SVGIcon, { type: isNavLoggedInIndicatorEnabled ? LogoutPerson : Person }),
        isShowMenu && (React.createElement(OverflowMenu, { items: dropDownList, isRightToLeft: isRightToLeft, onClickMenu: handleCloseMenu }))));
}
SignInMenuItem.displayName = 'SignInMenuItem';
